export function formattedPriceUtils(price, currency = 'BGN', locale = 'bg-BG') {

    const exchangeRate = 1.95583; // Фиксиран курс BGN към EUR
    let convertedPrice = price;

    if (currency === 'EUR') {
        convertedPrice = price / exchangeRate;
    }

    return new Intl.NumberFormat(locale, {style: 'currency', currency}).format(convertedPrice);
}